import addPrintListener from './addPrintListener';

const fireEvent = () =>
    window.location.pathname.includes('list') &&
  window.Checkout.analytics &&
  window.Checkout.analytics.logEvent &&
  window.Checkout.analytics.logEvent('ecommerce', 'print_wishlist', window.location.pathname);

const setupLogPrintListener = () => addPrintListener(fireEvent, () => {});

export default setupLogPrintListener;
